import React, { FC, useState } from 'react';
import { usePermissions, useTranslate } from 'react-admin';
import { CreateButton, Drawer } from '~/components';
import { CreateForm } from '~/components/ra';
import { history } from '~/App';
import onError from '~/errorsHandler';
import MenuForm from './MenuForm';
import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const l = (key: string): string => `resources.menu.copy.${key}`;

interface CreateDrawerProps {
  open: boolean;
  onClose: () => void;
  menuId: string;
}
const CreateDrawer: FC<CreateDrawerProps> = (props) => {
  const { open, onClose, menuId } = props;

  const handleError = (error: any) => {
    onError(error);
  };
  const handleClose = () => {
    onClose();
  };

  const { permissions } = usePermissions();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  if (!permissions?.includes('dynamicMenu.create')) return null;
  return (
    <Drawer open={open} onClose={handleClose} heading={t('title')}>
      <CreateForm
        resource='menu'
        id={menuId}
        subresource='copy'
        onSuccess={(res: any) => {
          const newMenuId = res?.data?.id; // Ensure the correct path to the ID
          if (newMenuId) {
            handleClose();
            history.push(`/menu/${newMenuId}/show`);
          } else {
            handleError(new Error(t('error')));
          }
        }}
        onError={handleError}
        disabled={!permissions?.includes('dynamicMenu.create')}
        withSaveConfirmation
        saveConfirmationSettings={{
          variant: 'modal',
          modal: {
            heading: t('attention'),
            content: (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Alert severity='warning'>{t('confirmAlert')}</Alert>
                </Grid>
              </Grid>
            ),
          },
        }}
      >
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Alert severity='warning'>{t('warningAlert')}</Alert>
            </Grid>
            <Grid item xs={12}>
              <MenuForm />
            </Grid>
          </Grid>
        </>
      </CreateForm>
    </Drawer>
  );
};

interface CopyActionProps {
  menuId: string;
}

const CopyAction: FC<CopyActionProps> = (props) => {
  const { menuId } = props;
  const { permissions } = usePermissions();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  if (!permissions?.includes('dynamicMenu.create')) return null;
  return (
    <>
      <CreateButton icon={<FileCopyIcon />} onClick={handleOpen} label={t('copy')} />
      <CreateDrawer open={open} onClose={handleClose} menuId={menuId} />
    </>
  );
};

export default CopyAction;
